import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=0358bd4a"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0358bd4a')) {
      api.createRecord('0358bd4a', component.options)
    } else {
      api.reload('0358bd4a', component.options)
    }
    module.hot.accept("./MultiSelect.vue?vue&type=template&id=0358bd4a", function () {
      api.rerender('0358bd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/MultiSelect.vue"
export default component.exports